import { render, staticRenderFns } from "./VDateField.vue?vue&type=template&id=b4bb48c4&"
import script from "./VDateField.vue?vue&type=script&lang=js&"
export * from "./VDateField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports